import { HoldEventUnitView, PillUnit } from '@mark43/cad-api';

export function convertHoldEventUnitViewToPillUnit(unit: HoldEventUnitView): PillUnit {
    return {
        callSign: unit.callSign.label,
        id: unit.id,
        unitStateGroup: unit.unitStateGroup,
        isPrimary: unit.isPrimary,
        isAssignedToAnotherEvent: false,
        isHeld: false,
        isTemporary: false,
        unitStateId: 0,
        eventId: 0,
        unitStateDisplayValue: '',
        unitStatusUpdatedDateUtc: '',
    };
}
